module.exports = __webpack_public_path__ + "img/AgaInsta_Final.361e0c30.jpg";